<template>
  <div class="row mt-2 g-3">
    <div class="col-12 col-lg-6 col-xl-3">
      <div role="button" class="card custom-card border shadow-sm h-100 cursor-pointer stat-card" style="background-color: white !important;border-color: #0688FC !important;"
        @click="toggleDetailPemutakhiranJumlahPenerbitanIzin(true)">
        <div class="card-body p-3 d-flex flex-column justify-content-between">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <span class="dp-card-title">Jumlah KKPRL</span>
            <div
              class="icon-shape bg-primary-soft text-primary rounded-circle p-2 d-flex align-items-center justify-content-center"
              style="width: 38px; height: 38px;">
              <i class="fa fa-check-square fs-6"></i>
            </div>
          </div>
          <div class="d-flex align-items-baseline justify-content-between">
            <h3 class="font-weight-bold text-dark m-0">{{ dataPemutakhiran.jumlah_penerbitan_izin || 0 }}</h3>
            <span class="extra-small text-muted">Dokumen</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 2: Habis Masa Berlaku -->
    <div class="col-12 col-lg-6 col-xl-3">
      <div role="button" class="card custom-card border shadow-sm h-100 cursor-pointer stat-card" style="background-color: white !important;border-color: #FFC107 !important;"
        @click="toggleDetailPemutakhiranHabisMasaBerlaku(true)">
        <div class="card-body p-3 d-flex flex-column justify-content-between">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <span class="dp-card-title">Habis Masa Berlaku</span>
            <div
              class="icon-shape bg-warning-soft text-warning rounded-circle p-2 d-flex align-items-center justify-content-center"
              style="width: 38px; height: 38px;">
              <i class="fa fa-hourglass-half fs-6"></i>
            </div>
          </div>
          <div class="d-flex align-items-baseline justify-content-between">
            <h3 class="font-weight-bold text-dark m-0">{{ dataPemutakhiran.habis_masa_berlaku || 0 }}</h3>
            <span class="extra-small text-muted">Dokumen</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 3: Pencabutan KKPRL -->
    <div class="col-12 col-lg-6 col-xl-3">
      <div role="button" class="card custom-card border shadow-sm h-100 cursor-pointer stat-card" style="background-color: white !important;border-color: #DC3545 !important;"
        @click="toggleDetailPemutakhiranPencabutanKkprl(true)">
        <div class="card-body p-3 d-flex flex-column justify-content-between">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <span class="dp-card-title">Pencabutan KKPRL</span>
            <div
              class="icon-shape bg-danger-soft text-danger rounded-circle p-2 d-flex align-items-center justify-content-center"
              style="width: 38px; height: 38px;">
              <i class="fa fa-file-text-o fs-6"></i>
            </div>
          </div>
          <div class="d-flex align-items-baseline justify-content-between">
            <h3 class="font-weight-bold text-dark m-0">{{ dataPemutakhiran.pencabutan || 0 }}</h3>
            <span class="extra-small text-muted">Dokumen</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 4: Pembatalan KKPRL -->
    <div class="col-12 col-lg-6 col-xl-3">
      <div role="button" class="card custom-card border shadow-sm h-100 cursor-pointer stat-card" style="background-color: white !important;border-color: #6C757D !important;"
        @click="toggleDetailPemutakhiranPembatalanKkprl(true)">
        <div class="card-body p-3 d-flex flex-column justify-content-between">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <span class="dp-card-title">Pembatalan KKPRL</span>
            <div
              class="icon-shape bg-secondary-soft text-secondary rounded-circle p-2 d-flex align-items-center justify-content-center"
              style="width: 38px; height: 38px;">
              <i class="fa fa-times fs-6"></i>
            </div>
          </div>
          <div class="d-flex align-items-baseline justify-content-between">
            <h3 class="font-weight-bold text-dark m-0">{{ dataPemutakhiran.pembatalan || 0 }}</h3>
            <span class="extra-small text-muted">Dokumen</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Components -->
    <DetailPemutakhiranJumlahPenerbitanIzin :show="showDetailPemutakhiranJumlahPenerbitanIzin"
      @close="toggleDetailPemutakhiranJumlahPenerbitanIzin" :filter-tahun="filterTahunPemutakhiran" />
    <DetailPemutakhiranHabisMasaBerlaku :show="showDetailPemutakhiranHabisMasaBerlaku"
      @close="toggleDetailPemutakhiranHabisMasaBerlaku" :filter-tahun="filterTahunPemutakhiran" />
    <DetailPemutakhiranPencabutanKkprl :show="showDetailPemutakhiranPencabutanKkprl"
      @close="toggleDetailPemutakhiranPencabutanKkprl" :filter-tahun="filterTahunPemutakhiran" />
    <DetailPemutakhiranPembatalanKkprl :show="showDetailPemutakhiranPembatalanKkprl"
      @close="toggleDetailPemutakhiranPembatalanKkprl" :filter-tahun="filterTahunPemutakhiran" />
  </div>
</template>

<script>
import DetailPemutakhiranHabisMasaBerlaku from '../DetailDashboard/DetailPemutakhiranHabisMasaBerlaku.vue'
import DetailPemutakhiranJumlahPenerbitanIzin from '../DetailDashboard/DetailPemutakhiranJumlahPenerbitanIzin/DetailPemutakhiranJumlahPenerbitanIzin.vue'
import DetailPemutakhiranPembatalanKkprl from '../DetailDashboard/DetailPemutakhiranPembatalanKkprl.vue'
import DetailPemutakhiranPencabutanKkprl from '../DetailDashboard/DetailPemutakhiranPencabutanKkprl.vue'

export default {
  components: {
    DetailPemutakhiranJumlahPenerbitanIzin,
    DetailPemutakhiranHabisMasaBerlaku,
    DetailPemutakhiranPencabutanKkprl,
    DetailPemutakhiranPembatalanKkprl,
  },
  props: ['dataPemutakhiran', 'filterTahunPemutakhiran'],
  data() {
    return {
      showDetailPemutakhiranJumlahPenerbitanIzin: false,
      showDetailPemutakhiranHabisMasaBerlaku: false,
      showDetailPemutakhiranPencabutanKkprl: false,
      showDetailPemutakhiranPembatalanKkprl: false,
    }
  },
  methods: {
    toggleDetailPemutakhiranJumlahPenerbitanIzin(val) {
      this.showDetailPemutakhiranJumlahPenerbitanIzin = val
    },
    toggleDetailPemutakhiranHabisMasaBerlaku(val) {
      this.showDetailPemutakhiranHabisMasaBerlaku = val
    },
    toggleDetailPemutakhiranPencabutanKkprl(val) {
      this.showDetailPemutakhiranPencabutanKkprl = val
    },
    toggleDetailPemutakhiranPembatalanKkprl(val) {
      this.showDetailPemutakhiranPembatalanKkprl = val
    },
  },
}
</script>

<style scoped>
.h-auto {
  height: auto !important;
}

@media (min-width: 1200px) {
  .h-auto {
    height: 100% !important;
  }
}

.stat-card {
  background-color: #f8fafc !important;
  /* Warna latar kartu agar kontras dengan background putih */
  border: 1px solid #e2e8f0 !important;
  /* Border terang untuk garis batas jelas */
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.stat-card:hover {
  background-color: #ffffff !important;
  /* Berubah putih saat di-hover */
  transform: translateY(-3px);
  border-color: #cbd5e1 !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04) !important;
}

/* Background icon lembut */
.bg-primary-soft {
  background-color: rgba(13, 110, 253, 0.12);
}

.bg-warning-soft {
  background-color: rgba(255, 193, 7, 0.18);
}

.bg-danger-soft {
  background-color: rgba(220, 53, 69, 0.12);
}

.bg-secondary-soft {
  background-color: rgba(108, 117, 125, 0.12);
}

.cursor-pointer {
  cursor: pointer;
}

.dp-card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    letter-spacing: -0.2px;
}
</style>
